import { trigger, transition, group, query, style, animate } from '@angular/animations';

export const generateAnimationBasedOnPagePaddings = (
  paddingTop: number = 0,
  paddingBottom: number = 0
) => {
  return trigger('routeAnimation', [
    transition('1 => 2, 2 => 3', [
      style({ height: '*', overflow: 'hidden' }),
      query(':enter', style({ transform: 'translateX(100%)', opacity: 0 })),
      query(
        ':enter, :leave',
        style({
          position: 'absolute',
          top: paddingTop,
          opacity: 0,
          left: 0,
          right: 0,
          margin: 'inherit',
          bottom: paddingBottom,
        })
      ),
      group([
        query(':leave', [style({ opacity: 1 }), animate('0.3s', style({ opacity: 0 }))], {
          optional: true,
        }),
        query(':leave', [
          animate(
            '0.6s cubic-bezier(.35,0,.25,1)',
            style({ transform: 'translateX(-100%)' })
          ),
        ]),
        query(
          ':enter',
          animate('0.6s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)' }))
        ),
        query(':enter', [style({ opacity: 0 }), animate('0.3s', style({ opacity: 1 }))], {
          optional: true,
        }),
      ]),
    ]),
    transition('3 => 2, 2 => 1', [
      style({
        height: '*',
        overflow: 'hidden',
      }),
      query(':enter', style({ transform: 'translateX(-100%)', opacity: 0 })),
      query(
        ':enter, :leave',
        style({
          position: 'absolute',
          top: paddingTop,
          left: 0,
          right: 0,
          bottom: paddingBottom,
          margin: 'inherit',
        })
      ),
      group([
        query(':leave', [style({ opacity: 1 }), animate('0.3s', style({ opacity: 0 }))], {
          optional: true,
        }),
        query(':leave', [
          animate(
            '0.6s cubic-bezier(.35,0,.25,1)',
            style({ transform: 'translateX(100%)' })
          ),
        ]),
        query(
          ':enter',
          animate('0.6s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)' }))
        ),
        query(':enter', [style({ opacity: 0 }), animate('0.3s', style({ opacity: 1 }))], {
          optional: true,
        }),
      ]),
    ]),
  ]);
};
